export const LOVE_CARDS = [
  ["L", "Layers", "Consider skin and tissue history, including existing pigment and previous procedures."],
  ["O", "Optics", "Explore how skin and light influence the appearance of color."],
  ["V", "Variables", "Bring together technique, desired results, pigment evidence, and your available kit."],
  ["E", "Evaluation", "Compare supported options, understand tradeoffs, and make your professional decision."],
];

export function LoveCards() {
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="love-cards">
      {LOVE_CARDS.map(([l, n, d], i) => (
        <div key={l} className="ig-rise rounded-2xl border border-[#E6DBCF] bg-white/70 p-5" style={{ animationDelay: `${i * 0.08}s` }} data-testid={`love-card-${l}`}>
          <div className="flex items-baseline gap-3">
            <span className="font-serif text-4xl italic leading-none text-[#C5A059]">{l}</span>
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#2C1810]">{n}</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-[#4A3B32]">{d}</p>
        </div>
      ))}
    </div>
  );
}

export const PRO_USE_TEXT =
  "Ink Genius supports professional judgment. Photos provide context, but cannot confirm pigment chemistry, precise implantation depth, or whether tissue is ready for treatment. Recommendations depend on the information and evidence available. Healed results cannot be guaranteed.";

export const ACK_TEXT =
  "I understand that Ink Genius provides educational decision support and that the treating professional makes the final treatment decision.";
